import ClearIcon from '@mui/icons-material/Clear';
import FilterListIcon from '@mui/icons-material/FilterList';
import { Box, Button, IconButton, InputAdornment, TextField } from '@mui/material';
import React from 'react';
import { ToolbarActions } from './ToolbarActions';
export const Toolbar = ({ filterPanelVisible, filterChanged, filterCount, fullTextSearchInitialValue, toolbarComponent, toolbarActions, onQuickSearch, onFilter, }) => {
    const [query, setQuery] = React.useState(fullTextSearchInitialValue !== null && fullTextSearchInitialValue !== void 0 ? fullTextSearchInitialValue : '');
    const handleQueryChange = (event) => {
        setQuery(event.target.value);
    };
    const handleQueryClear = () => {
        setQuery('');
    };
    React.useEffect(() => {
        let timeoutId = undefined;
        if (query != null) {
            timeoutId = window.setTimeout(() => {
                if (onQuickSearch) {
                    onQuickSearch(query);
                }
                timeoutId = undefined;
            }, 1000);
        }
        return () => {
            if (timeoutId) {
                window.clearTimeout(timeoutId);
                timeoutId = undefined;
            }
        };
    }, [onQuickSearch, query]);
    React.useEffect(() => {
        if (fullTextSearchInitialValue && onQuickSearch) {
            setQuery(fullTextSearchInitialValue);
        }
    }, [fullTextSearchInitialValue, onQuickSearch]);
    const ToolbarComponent = toolbarComponent;
    if (ToolbarComponent || onQuickSearch || onFilter || (toolbarActions === null || toolbarActions === void 0 ? void 0 : toolbarActions.length)) {
        return (React.createElement(Box, { sx: {
                display: 'flex',
                alignItems: 'center',
                padding: 2,
                minHeight: 36, // happens to be "Filter" button height}}>
            }, "data-test": 'toolbar' },
            !filterPanelVisible && onFilter && (React.createElement(Button, { sx: { marginRight: ToolbarComponent || (toolbarActions === null || toolbarActions === void 0 ? void 0 : toolbarActions.length) ? 2 : 0 }, onClick: onFilter, variant: 'outlined', color: 'primary', startIcon: React.createElement(FilterListIcon, null), "data-test": 'toolbar-filter-button' },
                "Filter ",
                filterCount > 0 ? '(' + filterCount + ')' : '')),
            onQuickSearch && (React.createElement(TextField, { sx: { width: 'min(320px, 100%)', marginRight: ToolbarComponent || (toolbarActions === null || toolbarActions === void 0 ? void 0 : toolbarActions.length) ? 2 : 0 }, label: 'Search', size: 'small', value: query, onChange: handleQueryChange, InputProps: {
                    endAdornment: query.trim().length > 0 ? (React.createElement(InputAdornment, { position: 'end' },
                        React.createElement(IconButton, { size: 'medium', edge: 'end', onClick: handleQueryClear, onMouseDown: (event) => event.preventDefault() },
                            React.createElement(ClearIcon, null)))) : null,
                }, "data-test": 'toolbar-quick-search-input' })),
            ToolbarComponent && (React.createElement(ToolbarComponent, { filterPanelVisible: filterPanelVisible, filterChanged: filterChanged, filterCount: filterCount, searchVisible: !!onQuickSearch })),
            !ToolbarComponent && !!(toolbarActions === null || toolbarActions === void 0 ? void 0 : toolbarActions.length) && (React.createElement(ToolbarActions, { actions: toolbarActions, filterPanelVisible: filterPanelVisible, searchVisible: !!onQuickSearch }))));
    }
    else {
        return null;
    }
};
